<template>
  <el-dialog
    title="转发"
    :visible.sync="visible"
    width="500px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div class="forward-form">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="接收人">
          <el-select
            class="w-320px"
            v-model="userId"
            filterable
            clearable
            placeholder="请输入关键词搜索"
            :loading="loading"
          >
            <el-option
              v-for="item in receivers"
              :key="item.Id"
              :label="item.Account"
              :value="item.Id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="接收人姓名">
          <el-input v-model="form.receiverName" disabled />
        </el-form-item>
        <el-form-item label="组织机构">
          <el-input v-model="form.organization" disabled />
        </el-form-item>
        <el-form-item label="账号状态">
          <el-input v-model="form.accountStatus" disabled />
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ForwardDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userId: '',
      form: {
        receiverId: '',
        receiverName: '',
        organization: '',
        accountStatus: '',
      },
      receivers: [],
      loading: false,
      submitting: false,
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.getReceivers()
      }
    },
    userId(val) {
      console.log(val, 'userId')
      const selectedReceiver = this.receivers.find((item) => {
        return item.Id === val
      })
      console.log(selectedReceiver)
      if (selectedReceiver) {
        this.form.receiverName = selectedReceiver.Name
        this.form.organization = selectedReceiver.DeptName
        this.form.accountStatus = selectedReceiver.State === 1 ? '正常' : '禁用'
      }
    },
  },
  methods: {
    // 远程搜索接收人
    getReceivers() {
      const instance = axios.create()
      instance.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem(
        'authorization'
      )}`
      instance.defaults.headers.common['Content-Type'] = 'application/json'
      instance.defaults.baseURL = localStorage.getItem('DiyApiBase')
      instance
        .post('/api/FormEngine/getTableData-sys-user', {
          ModuleEngineKey: 'Sys_User',
          _PageIndex: 1,
          _PageSize: 10000,
        })
        .then((res) => {
          console.log(res)
          if (res.data.Code === 1) {
            this.receivers = res.data.Data
          }
        })
    },

    // 提交转发
    async handleSubmit() {
      if (!this.userId) {
        this.$message.warning('请选择接收人')
        return
      }
      this.submitting = true
      this.$emit('saveAndSend', this.userId)
    },

    // 关闭弹窗
    handleClose() {
      this.userId = ''
      this.form = {
        receiverName: '',
        organization: '',
        accountStatus: '',
      }
      this.receivers = []
      this.$emit('update:visible', false)
    },
  },
  created() {
    this.getReceivers()
  },
}
</script>

<style lang="scss" scoped>

.forward-form {
  padding: 0 20px;
}

</style>
